import axios from 'axios';

const SUBACCOUNT_PERMISSIONS_PATH = 'users/subaccount/permissions';

export default {
    namespaced: true,
    state: {
        permissions: null,
        hasError: false,
        errorMsg: '',
    },
    getters: {
        getPermissionsResource(state) {
            const self = this; // eslint-disable-line
            return function(resourceType) {
                return state && state.permissions && state.permissions.find(itrem => itrem.type === resourceType)
            };
        },
    },
    mutations: {
        setPermissions(state, permissions) {
            state.permissions = permissions;
        },
        setError(state, error) {
            state.hasError = true;
            state.errorMsg = error;
        },
        clearError(state) {
            state.hasError = false;
            state.errorMsg = ''; 
        },
    },
    actions: {
        async findPermissions({ commit }) {
            try {
                const { data } = await axios.get(`${process.env.VUE_APP_ACCOUNTS_API}/${SUBACCOUNT_PERMISSIONS_PATH}`);
                commit('setPermissions', data.data);
            } catch (error) {
                commit('setPermissions', error.error);
            }
        },
    }
};